<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>
  <ng-container header>
    <email-message-header [header]="data().title" [separator]="false" />
    <email-margin [height]="20" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data().p1" />
    <email-margin [height]="28" />
    <email-text [contents]="data().p2" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text [contents]="data().p3" />
    <email-margin [height]="28" />
    <email-button [href]="data().button_link" [label]="data().button_text" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
